(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.sticky = this.header.querySelector('sticky-header');
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      document.addEventListener('DOMContentLoaded', this.convertToFixed);
      window.addEventListener('resize', this.convertToFixed, {passive: true});

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    convertToFixed = () => {
      this.header.style.setProperty('--sticky-header-height', `${this.sticky.offsetHeight}px`);
      this.sticky.style.position = 'fixed';
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollThreshold = 80;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > scrollThreshold) {
        this.shrink();
      } else {
        this.expand();
      }
    }

    shrink() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.header.classList.add('shopify-section-header-scrolled');
    }

    expand() {
      this.expanded = true;
      this.header.classList.remove('shopify-section-header-scrolled');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  const heroSlideshows = document.querySelectorAll('.hero-slideshow');
  heroSlideshows.forEach(section => {
    const buttons = [...section.querySelectorAll('[data-activate-slide]')];
    const slides  = [...section.querySelectorAll('[data-slide]')];
    let currentIndex = 0;

    let timeout = setTimeout(nextSlide, 4000);

    buttons.forEach(button => button.addEventListener('click', activateOnClick));

    function activateSlide(slideNum) {
      let slide = slides[currentIndex];
      let button = buttons[currentIndex];
      slide.removeAttribute('data-active');
      button.removeAttribute('data-current');

      currentIndex = slideNum % slides.length;

      slide = slides[currentIndex];
      button = buttons[currentIndex];
      slide.setAttribute('data-active', 'true');
      button.setAttribute('data-current', 'true');

      queueNextSlide();
    }

    function activateOnClick(e) {
      const slideNum = Number(e.currentTarget.getAttribute('data-activate-slide'));
      activateSlide(slideNum - 1);
    }

    function queueNextSlide() {
      clearTimeout(timeout);
      timeout = setTimeout(nextSlide, 4000);
    }

    function nextSlide() {
      activateSlide(currentIndex + 1);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nu-expandable-text"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
        const triggers = document.querySelectorAll('.nu-expandable-text__toggle');
        triggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                const isOpen = trigger.getAttribute('aria-expanded') === 'true';
                const parentSection = document.getElementById(trigger.getAttribute('aria-controls'));

                if (isOpen) {
                    parentSection.classList.remove('open');
                    trigger.setAttribute('aria-expanded', 'false');
                } else {
                    parentSection.classList.add('open');
                    trigger.setAttribute('aria-expanded', 'true');
                }
            })
        });
    })

  } catch(e) { console.error(e); }
})();
})();
